/**
 * Client fetch cho API nội bộ. Chuẩn hóa response { data } | { error }.
 */
export interface ApiError {
  code: string;
  message: string;
  fieldErrors?: Record<string, string>;
  retryable?: boolean;
}

export class ApiClientError extends Error {
  code: string;
  fieldErrors?: Record<string, string>;
  constructor(err: ApiError) {
    super(err.message);
    this.code = err.code;
    this.fieldErrors = err.fieldErrors;
  }
}

async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  const res = await fetch(path, {
    method,
    headers: body !== undefined ? { "Content-Type": "application/json" } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const json = await res.json().catch(() => null);
  if (!res.ok || !json || "error" in json) {
    throw new ApiClientError(
      json?.error ?? { code: "network_error", message: "Không thể kết nối máy chủ." }
    );
  }
  return json.data as T;
}

export const apiGet = <T>(path: string) => request<T>("GET", path);
export const apiPost = <T>(path: string, body?: unknown) => request<T>("POST", path, body);
export const apiPut = <T>(path: string, body?: unknown) => request<T>("PUT", path, body);
export const apiPatch = <T>(path: string, body?: unknown) => request<T>("PATCH", path, body);
export const apiDelete = <T>(path: string, body?: unknown) => request<T>("DELETE", path, body);
